import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import waterfall from 'vue-waterfall2'
import VueMeta from 'vue-meta'

import 'reset-css'
import 'iview/dist/styles/iview.css';
import './assets/css/index.less'
import './assets/css/media.less'
import api from './common/api.config'
import VueLazyload from 'vue-lazyload'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

Vue.use(waterfall)

Vue.use(iView);
Vue.use(VueLazyload);
Vue.use(Viewer);
Vue.use(VueMeta);

Vue.prototype.$api = api;
Vue.config.productionTip = false

Vue.use(VueLazyload, {  
  preLoad: 1.3,                //预加载的宽高比
  error: './assets/image/errorImage.png',     //图片加载失败时使用的图片源
  loading: '', //图片加载的路径
  attempt: 1                   //尝试加载次数
})

window.eventBus = new Vue();

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js